// Libraries
import React from 'react'

// Layouts
import { MainWrapperWithCaptions } from '../../layouts/MainWrapperWithCaptions'
import { ColumnMargin, Description, RestrictedByWidth } from '../../layouts/MainWrapperWithCaptions/style'
import { ArrowLeft, TextButton } from '../../ui/TextButton'

// Styles
import {
  BookClosedAbsolute,
  BorderedWrap,
  EndingTitle, LinkHomePage,
  TextDescriptionCenter,
  TextDescriptionFinalPage,
  WrapImg
} from '../../style'

interface IProps {
  setStageAndToTop: (arg0: number) => void;
  appendData: (arg0: object) => void;
  currentStage: number;
  firstname: object;
}

export const StageFive = ({ currentStage, setStageAndToTop, appendData, firstname  }: IProps) => {
  return (
    <>
      <MainWrapperWithCaptions key={5}>
        <EndingTitle>{<>“Vielen Dank für Deine <br /> Anmeldung, {firstname}</>}</EndingTitle>
        <Description $textAlign='center'><>Ich hoffe, unsere Tipps sind für Deinen nächsten <br /> Charterurlaub hin</></Description>
        <BorderedWrap>
          <BookClosedAbsolute src='/book.webp' />
          <TextDescriptionCenter>Bitte schaue in Dein Email Postfach und bestätige kurz Deine Email. Anschliessend bekommst
            Du von mir sofort unsere Tipps zugeschickt</TextDescriptionCenter>
        </BorderedWrap>
        <ColumnMargin>
          <LinkHomePage href='https://www.yachtcharterfinder.com/'>Zur Homepage</LinkHomePage>
          <TextButton onClick={() => setStageAndToTop(4)}>
            <ArrowLeft width="10" height="21" viewBox="0 0 10 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 1L0.999999 10.5L9 20" stroke="white" strokeWidth="1.5"/>
            </ArrowLeft>
            Zurück
          </TextButton>
        </ColumnMargin>
        <RestrictedByWidth>
          <WrapImg>
            <img src="/face.png" alt=""/>
          </WrapImg>
          <TextDescriptionFinalPage>Und solltest Du einen persönlichen Ratschlag brauchen, kannst Du mich jederzeit anrufen oder mir eine Email schreiben. <br />
            <img src="/phone_icon.svg" alt=""/> +49 30 2018 1715 <br />
            <img src="/email_icon.svg" alt=""/> karsten.knorr@yachtcharterfinder.com
          </TextDescriptionFinalPage>
        </RestrictedByWidth>
      </MainWrapperWithCaptions>
    </>
  )
}
